export default __webpack_public_path__ + "static/media/whatyouget.6627034b.png";